import { SACI } from "@eldrun/content";

export interface PeneiraInput {
  /** Redemoinho em que a captura está acontecendo (pedido feito), se houver. */
  on: string | undefined;
  /** Peneira na mão, ação apertada, painel aberto, morto. */
  holding: boolean;
  down: boolean;
  panel: boolean;
  dead: boolean;
  now: number;
  retryAt: number;
  /** Distância 3D (a mesma do servidor) até cada redemoinho. */
  winds: readonly { id: string; d: number }[];
}

export interface PeneiraStep {
  on: string | undefined;
  retryAt: number;
  /** Mensagem a mandar ao servidor. */
  send?: { id: string; holding: boolean };
  /** O clique foi da Peneira (não vira golpe). */
  consumed: boolean;
}

/** Folga para não soltar por um tremor da interpolação no limite do alcance. */
const SLACK = 0.3;
/** Espera entre pedidos enquanto segura (recusado pelo servidor). */
const RETRY_MS = 300;

/**
 * Peneira no cliente (doc 06): começa a captura no redemoinho mais perto a até 3 m em 3D (a regra
 * do servidor) enquanto a ação está apertada; para ao soltar, trocar de item, abrir painel, morrer,
 * o redemoinho sumir ou sair do alcance; recusada ou interrompida, tenta de novo a cada 0,3 s.
 */
export function peneiraStep(s: PeneiraInput): PeneiraStep {
  if (s.on) {
    const w = s.winds.find((x) => x.id === s.on);
    const stop = !s.down || !s.holding || s.panel || s.dead || !w || w.d > SACI.reach + SLACK;
    if (!stop) return { on: s.on, retryAt: s.retryAt, consumed: true };
    return { on: undefined, retryAt: s.retryAt, consumed: true, ...(w ? { send: { id: s.on, holding: false } } : {}) };
  }
  if (!s.holding || !s.down || s.panel || s.dead || s.now < s.retryAt) return { on: undefined, retryAt: s.retryAt, consumed: false };
  let best: { id: string; d: number } | undefined;
  for (const w of s.winds) if (w.d <= SACI.reach && (!best || w.d < best.d)) best = w;
  if (!best) return { on: undefined, retryAt: s.retryAt, consumed: false };
  return { on: best.id, retryAt: s.now + RETRY_MS, consumed: true, send: { id: best.id, holding: true } };
}
